import { z } from "zod/v4";

import { userSchema } from "./User";

export const reactionSchema = z.object({
	id: z.string(),
	linkedRecordId: z.string(),
	user: z.union([z.string().transform((str) => JSON.parse(str)), userSchema]).pipe(userSchema),
	createdAt: z.number(),
});
export type Reaction = z.infer<typeof reactionSchema>;
